import React from 'react';
import { rememberReturnPath } from '../lib/workspaceStorage';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../lib/permissions';
import { profileGateRequired, isGateAllowedPath, profilePath } from '../lib/profileGate';

// requiredPermission only hides a page; the API checks the same permission on every request.
export const ProtectedRoute = ({ children, allowedRoles = [], requiredPermission = null }) => {
  const { user, loading, authError, checkAuth } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-black border-t-transparent animate-spin mx-auto mb-4"></div>
          <p className="text-sm uppercase tracking-[0.2em]">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (authError) return <div role="alert" className="p-8 text-center"><p>{authError}</p><button className="action-primary mt-4" onClick={checkAuth}>Tekrar dene</button></div>;
  if (!user) {
    rememberReturnPath();
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to="/" replace />;
  }
  // A5b: zorunlu profil bilgisi eksikse izinli sayfalar dışındaki her rota profil tamamlamaya gider (sunucu da 409 ile korur).
  // Yetkiyle açılan personel sayfaları (requiredPermission) üye işi değildir; üye hesabına bağlı personel engellenmez.
  if (!requiredPermission && profileGateRequired(user) && !isGateAllowedPath(user.role, location.pathname)) {
    return <Navigate to={profilePath(user.role)} replace />;
  }

  return <React.Fragment key={user.id || user._id}>{children}</React.Fragment>;
};
